import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { NgxTolgeeModule } from '@tolgee/ngx';

import { ContactComponent } from './contact/contact.component';

@Component({
  selector: 'app-cse-infos',
  imports: [
    NgOptimizedImage,
    NgxTolgeeModule,
    ContactComponent
  ],
  templateUrl: './cse.component.html'
})
export class CseComponent {

}
